import React, { useEffect, useState, useRef } from "react";
import classes from "./Myschedule.module.css";
import Card from "../../UI/Card/Card";
import { Col, Form, Row } from "react-bootstrap";
import { couterArrayFn, isEmpty } from "../../utils/custom_funtions";
import SecBTN from "../../UI/SecBTN";
import CustomModal from "../../UI/Modals/Modals";
import Select from "../../UI/Select/Select";
import Input from "../../UI/Input/Input";
import userService from "../../app/services/user.service";
import { toast } from "react-toastify";
import Toast from "../../UI/Toast/Toast";
import SmallLoader from "../../UI/SmallLoader/SmallLoader";
import { Modal, Button } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import ConfirmationModal from '../../UI/ConfirmationModal/ConfirmationModal';
import Modals from "../../UI/Modals/Modals";
import { Link } from "react-router-dom";
import { useNavigate } from 'react-router-dom';
import { useLocation } from "react-router-dom";



const ScheduleCard = (props) => {
  const formRef = useRef();
  const data = props.data;
  const [show, setShow] = useState(false);
  const [showAttendance, setShowAttendance] = useState(false);
  const [loading, setLoading] = useState(false);
  const [topicList, setTopicList] = useState([]);
  const [attendanceData, setAttendanceData] = useState({});
  const [subTopicList, setSubTopicList] = useState([]);
  const [showPopUp1, setShowPopUp1] = useState(false);
  const [reason, setReason] = useState("")
  const [isSubmit, setIsSubmit] = useState(false);
  const [isHomework, setIsHomework] = useState(false);
  const [isForm, setIsForm] = useState(true);
  const navigate = useNavigate();
  const [showPopUp, setShowPopUp] = useState(false);
  const [reqData, setReqData] = useState({
    doubt_class: "0",
    dpp_discussion: "0",
    dpp_discussion_detail: "",
    extra_class: "0",
    extra_class_detail: "",
    is_topic_finish: "0",
    topic_no_count: "",
    module_sheet_discussion: "0",
    module_sheet_disscussion_ex_level: "",
    module_sheet_disscussion_title: "",
    remark: "",
    schedule_id: "",
    select_class_time: "",
    select_sub_topic: "",
    select_sub_topic_title: "",
    test_paper_discussion: "0",
    test_paper_discussion_detail: "",
    topic_title: "",
    homework_status:"",
    reason_homework_not_given:"Lorem ipsum dolor sit amet"
  });

  

  useEffect(() => {
    setReqData((prev) => {
      return {
        ...prev,
        topic_title: data.topic,
        select_class_time: data.from_time,
        schedule_id: data.id,
        // schedule_id:data.id
      };
    });

    
   
  }, []);

 

  const GetTopicList = (id) => {
    userService
      .getTopicListBySid(id)
      .then((res) => {
        const datas = res.data.data;
        const index = datas.map((e) => e.topic_name).indexOf(data.topic);
        if (index === -1) {
          setTopicList(() => {
            return [...datas, { topic_name: data.topic }];
          });
        } else {
          setTopicList(datas);
          // console.log(datas[index].topic_id)
          getSubTopicList(datas[index].topic_id);
        }
      })
      .catch((err) => {
        console.log(err.response.data.info);
      });
  };

  const reasonList = [
    {
      "id": 1,
      "reason": "Lorem ipsum dolor sit amet"
    },
    {
      "id": 2,
      "reason": "Lorem ipsum dolor sit amet"
    },
    {
      "id": 3,
      "reason": "Lorem ipsum dolor sit amet"
    },
    {
      "id": 4,
      "reason": "Lorem ipsum dolor sit amet"
    },
    {
      "id": 5,
      "reason": "Lorem ipsum dolor sit amet"
    },
    {
      "id": 6,
     "reason": "Lorem ipsum dolor sit amet"
    },
    
  ]

  const getSubTopicList = (tid) => {
    userService
      .getSubTopicByTid(tid)
      .then((res) => {
        // console.log("setSubTopicList", res.data.data);
        setSubTopicList(res.data.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  

  useEffect(() => {
    GetTopicList(data.subject_id);
  }, [data, isSubmit]);

//  console.log(props.dataChanged());
  const addCourseReport = () => {
    console.log("Report Submitted");
    console.log(reqData);
    userService
      .addCourseReport(reqData)
      .then((res) => {
        console.log(res);
        if (res.data === true) {
          props.dataChanged();
          toast.success("Report Added Successfully.");
          setShow(false);
        } else {
          toast.error("Something went wrong!");
          setShow(false);
        }
        if (res.msg == "Course Report Successfully Submited") {
        }
      })
      .catch((err) => {
        console.log(err);
        toast.error("Something went wrong!");
      });
    setIsSubmit(false);
  };
  const getAttendanceData = () => {
    const body = {
      faculty_schedule_id: data.id,
      date: data.datte,
    };
    setLoading(true)
    userService.getAttendanceData(body)
      .then(res => {
        setLoading(false);
        if (res.data == "Not Found") {
          toast.error("Data not available")
          setShowAttendance(false);
          setAttendanceData({});
        } else {
          console.log(res.data);
          setAttendanceData(res.data);
          setShowAttendance(true);
        }
      })
      .catch(err => {
        setLoading(false);
        toast.error("Something went wrong!!")
        console.error(err);
      })
  }
  const viewAttendanceHandler = () => {
    getAttendanceData()
  }
  const onHideHandler = () => {
    setShowPopUp1(false)

  }
  const noHandler = () => {
    setShowPopUp(true)
    setShowPopUp1(false);
    reqData.homework_status='no';

    
  }
  const yesHandler = () => {
    setIsHomework(true);
    setIsForm(false);
    setShowPopUp1(false);
    setReqData((prev) => {
      return {
        ...prev,
       homework_status:"yes"
      }
    });
    navigate('./homework', { state: { facultyId: data.faculty_id, subjectId: data.subject_id, batch: data.batch, t_id: data.topic_id, id: data.id, reqData:reqData} });
  }
  const hideHandler = () => {
    setShowPopUp(false);
  }
  const handleReportSubmit = () => {
    setIsSubmit(true);
    setShowPopUp(false);
    addCourseReport();

  }

  const inputHandler = (data) => {

  }

  const handleHomeworkDetails=()=>{

    navigate("/HomeworkDetails",{state:{schedule_id:data.id}});
  }
 

  return (
    <>
      <Toast />
      <CustomModal show={show} size="lg" onHide={() => setShow(false)}>
        <h4 className="mb-2">Add class details</h4>
        {props.idDC ? (
          <form onSubmit={addCourseReport} >
        <Row className="gx-3 gy-2">
          <Col lg={6} md={6} sm={12}>
            <Form.Label>Doubt Class :</Form.Label>
            <div>
              <Form.Check
                inline
                type="radio"
                name="doubt_class"
                label="Yes"
                value="1"
                onChange={(e) => {
                  setReqData((prev) => {
                    return {
                      ...prev,
                      doubt_class: e.target.value,
                    };
                  });
                }}
                checked={reqData.doubt_class == "1"}
              />
              <Form.Check
                inline
                type="radio"
                name="doubt_class"
                label="No"
                value="0"
                onChange={(e) => {
                  setReqData((prev) => {
                    return {
                      ...prev,
                      doubt_class: e.target.value,
                    };
                  });
                }}
                checked={reqData.doubt_class == "0"}
              />
            </div>
          </Col>
          <Col lg={6} md={6} sm={12}>
            <Form.Label htmlFor="remark">Remark :</Form.Label>
            <Input
              type="text"
              id="remark"
              placeholder="Add Remark"
              value={reqData.remark}
              onChange={(e) => {
                setReqData((prev) => {
                  return {
                    ...prev,
                    remark: e.target.value,
                  };
                });
              }}
            />
          </Col>
        </Row>
        <div className="text-center mt-4">
          <SecBTN className="sec-btn1" type='submit' onClick={addCourseReport}>
            Add
          </SecBTN>

        </div>
      </form>
      ) : (
      <div>
        <form onSubmit={(e)=>e.preventDefault()} >
          <Row className="gx-3 gy-2">
            <Col lg={6} md={6} sm={12}>
              <Form.Label>Select topic :</Form.Label>
              <Select
                required
                className={classes.select}
                value={reqData.topic_title}
                onChange={(e) => {
                  const index = topicList
                    .map((e) => e.topic_name)
                    .indexOf(e.target.value);
                  getSubTopicList(topicList[index].topic_id);
                  setReqData((prev) => {
                    return {
                      ...prev,
                      topic_title: e.target.value,
                      select_sub_topic: "",
                      select_sub_topic_title: "",
                    };
                  });
                }}
              >
                {topicList.map((topic) => {
                  return (
                    <option value={topic.topic_name}>
                      {topic.topic_name}
                    </option>
                  );
                })}
              </Select>
            </Col>
            <Col lg={6} md={6} sm={12}>
              <Form.Label>Select Subtopic:</Form.Label>
              <Select
                required
                className={classes.select}
                value={reqData.select_sub_topic}
                onChange={(e) => {
                  setReqData((prev) => {
                    return {
                      ...prev,
                      select_sub_topic: e.target.value,
                      select_sub_topic_title: e.target.value,
                    };
                  });
                }}
              >
                <option value="" disabled>
                  Select Subtopic
                </option>
                {subTopicList.map((item) => {
                  return (
                    <option
                      value={item.Sub_topic_name}
                      data-bs={item.sub_topic_id}
                    >
                      {item.Sub_topic_name}
                    </option>
                  );
                })}
              </Select>
            </Col>
            <Col lg={6} md={6} sm={12}>
              <Form.Label htmlFor="SubTopic_title">
                SubTopic title :
              </Form.Label>
              <Input
                type="text"
                placeholder="Add SubTopic title"
                value={reqData.select_sub_topic_title}
                onChange={(e) => {
                  setReqData((prev) => {
                    return {
                      ...prev,
                      select_sub_topic_title: e.target.value,
                    };
                  });
                }}
              />
            </Col>
            <Col lg={6} md={6} sm={12}>
              <Form.Label>Is Chapter Finished :</Form.Label>
              <div>
                <Form.Check
                  inline
                  type="radio"
                  name="is_topic_finish"
                  label="Yes"
                  value="1"
                  onChange={(e) => {
                    setReqData((prev) => {
                      return {
                        ...prev,
                        is_topic_finish: e.target.value,
                      };
                    });
                  }}
                  checked={reqData.is_topic_finish == "1"}
                />
                <Form.Check
                  inline
                  type="radio"
                  name="is_topic_finish"
                  label="No"
                  value="0"
                  onChange={(e) => {
                    setReqData((prev) => {
                      return {
                        ...prev,
                        is_topic_finish: e.target.value,
                      };
                    });
                  }}
                  checked={reqData.is_topic_finish == "0"}
                />
              </div>
            </Col>
            <Col lg={6} md={6} sm={12}>
              <Form.Label>Select Lecture numbers :</Form.Label>
              <Select
                required
                className={classes.select}
                value={reqData.topic_no_count}
                onChange={(e) => {
                  setReqData((prev) => {
                    return {
                      ...prev,
                      topic_no_count: e.target.value,
                    };
                  });
                }}
              >
                <option value="" disabled>
                  Select Lecture number :
                </option>
                {couterArrayFn(30).map((num) => {
                  return <option value={num}>{num}</option>;
                })}
              </Select>
            </Col>
            <Col lg={6} md={6} sm={12}>
              <Form.Label>Module Sheet Discussion :</Form.Label>
              <div>
                <Form.Check
                  inline
                  type="radio"
                  name="module_sheet_discussion"
                  label="Yes"
                  value="1"
                  onChange={(e) => {
                    setReqData((prev) => {
                      return {
                        ...prev,
                        module_sheet_discussion: e.target.value,
                      };
                    });
                  }}
                  checked={reqData.module_sheet_discussion == "1"}
                />
                <Form.Check
                  inline
                  type="radio"
                  name="module_sheet_discussion"
                  label="No"
                  value="0"
                  onChange={(e) => {
                    setReqData((prev) => {
                      return {
                        ...prev,
                        module_sheet_discussion: e.target.value,
                      };
                    });
                  }}
                  checked={reqData.module_sheet_discussion == "0"}
                />
              </div>
            </Col>
            {reqData.module_sheet_discussion == "1" && (
              <>
                <Col lg={6} md={6} sm={12}>
                  <Form.Label>Exercise Level :</Form.Label>
                  <Select
                    className={classes.select}
                    value={reqData.module_sheet_disscussion_ex_level}
                    onChange={(e) => {
                      setReqData((prev) => {
                        return {
                          ...prev,
                          module_sheet_disscussion_ex_level: e.target.value,
                        };
                      });
                    }}
                  >
                    <option value="" disabled>
                      Select Exercise Level
                    </option>
                    {couterArrayFn(10).map((num) => {
                      return <option value={num}>{num}</option>;
                    })}
                  </Select>
                </Col>
                <Col lg={6} md={6} sm={12}>
                  <Form.Label htmlFor="remark">
                    Module Sheet Disscussion Title :
                  </Form.Label>
                  <Input
                    type="text"
                    id="module_sheet_disscussion_title"
                    placeholder="Module Sheet Disscussion Title"
                    value={reqData.module_sheet_disscussion_title}
                    onChange={(e) => {
                      setReqData((prev) => {
                        return {
                          ...prev,
                          module_sheet_disscussion_title: e.target.value,
                        };
                      });
                    }}
                  />
                </Col>
              </>
            )}
            <Col lg={6} md={6} sm={12}>
              <Form.Label>Test Paper Discussion :</Form.Label>
              <div>
                <Form.Check
                  inline
                  type="radio"
                  name="test_paper_discussion"
                  label="Yes"
                  value="1"
                  onChange={(e) => {
                    setReqData((prev) => {
                      return {
                        ...prev,
                        test_paper_discussion: e.target.value,
                      };
                    });
                  }}
                  checked={reqData.test_paper_discussion == "1"}
                />
                <Form.Check
                  inline
                  type="radio"
                  name="test_paper_discussion"
                  label="No"
                  value="0"
                  onChange={(e) => {
                    setReqData((prev) => {
                      return {
                        ...prev,
                        test_paper_discussion: e.target.value,
                      };
                    });
                  }}
                  checked={reqData.test_paper_discussion == "0"}
                />
              </div>
            </Col>
            {reqData.test_paper_discussion == "1" && (
              <Col lg={6} md={6} sm={12}>
                <Form.Label htmlFor="remark">Test Paper Details :</Form.Label>
                <Input
                  type="text"
                  id="test_paper_discussion_detail"
                  placeholder="Test Paper Details"
                  value={reqData.test_paper_discussion_detail}
                  onChange={(e) => {
                    setReqData((prev) => {
                      return {
                        ...prev,
                        test_paper_discussion_detail: e.target.value,
                      };
                    });
                  }}
                />
              </Col>
            )}
            <Col lg={6} md={6} sm={12}>
              <Form.Label>DPP Discussion :</Form.Label>
              <div>
                <Form.Check
                  inline
                  type="radio"
                  name="dpp_discussion"
                  label="Yes"
                  value="1"
                  onChange={(e) => {
                    setReqData((prev) => {
                      return {
                        ...prev,
                        dpp_discussion: e.target.value,
                      };
                    });
                  }}
                  checked={reqData.dpp_discussion == "1"}
                />
                <Form.Check
                  inline
                  type="radio"
                  name="dpp_discussion"
                  label="No"
                  value="0"
                  onChange={(e) => {
                    setReqData((prev) => {
                      return {
                        ...prev,
                        dpp_discussion: e.target.value,
                      };
                    });
                  }}
                  checked={reqData.dpp_discussion == "0"}
                />
              </div>
            </Col>
            {reqData.dpp_discussion == "1" && (
              <Col lg={6} md={6} sm={12}>
                <Form.Label htmlFor="remark">DPP Details :</Form.Label>
                <Input
                  type="text"
                  id="dpp_discussion_detail"
                  placeholder="Add DPP Details"
                  value={reqData.dpp_discussion_detail}
                  onChange={(e) => {
                    setReqData((prev) => {
                      return {
                        ...prev,
                        dpp_discussion_detail: e.target.value,
                      };
                    });
                  }}
                />
              </Col>
            )}
            <Col lg={6} md={6} sm={12}>
              <Form.Label>Extra Class :</Form.Label>
              <div>
                <Form.Check
                  inline
                  type="radio"
                  name="extra_class"
                  label="Yes"
                  value="1"
                  onChange={(e) => {
                    setReqData((prev) => {
                      return {
                        ...prev,
                        extra_class: e.target.value,
                      };
                    });
                  }}
                  checked={reqData.extra_class == "1"}
                />
                <Form.Check
                  inline
                  type="radio"
                  name="extra_class"
                  label="No"
                  value="0"
                  onChange={(e) => {
                    setReqData((prev) => {
                      return {
                        ...prev,
                        extra_class: e.target.value,
                      };
                    });
                  }}
                  checked={reqData.extra_class == "0"}
                />
              </div>
            </Col>
            {reqData.extra_class == "1" && (
              <Col lg={6} md={6} sm={12}>
                <Form.Label htmlFor="remark">
                  Extra Class Details :
                </Form.Label>
                <Input
                  type="text"
                  id="extra_class_detail"
                  placeholder="Add Extra Class Details"
                  value={reqData.extra_class_detail}
                  onChange={(e) => {
                    setReqData((prev) => {
                      return {
                        ...prev,
                        extra_class_detail: e.target.value,
                      };
                    });
                  }}
                />
              </Col>
            )}
            <Col lg={6} md={6} sm={12}>
              <Form.Label htmlFor="remark">Remark :</Form.Label>
              <Input
                type="text"
                id="remark"
                placeholder="Add Remark"
                value={reqData.remark}
                onChange={(e) => {
                  setReqData((prev) => {
                    return {
                      ...prev,
                      remark: e.target.value,
                    };
                  });
                }}
              />
            </Col>
          </Row>
          <div className="text-center mt-4">
            <SecBTN className="sec-btn1" onClick={() =>{ setShowPopUp1(true) }} >
              Add
            </SecBTN>
          </div>
        </form>
        <ConfirmationModal
          title="Do You Want to give Homework Today"
          show={showPopUp1}
          onHide={onHideHandler}
          yesHandler={yesHandler}
          noHandler={noHandler}

          confirmTxt="yes"
        />
        <Modals show={showPopUp} onHide={hideHandler}>
          <Row className="g-3">
            <Col sm={12}>
              <Form.Label>Please Add the reason for not assigning homework for the day in remarkable field*</Form.Label>
              <Select value={["option1"]} onChange={e => setReason(prev => {
                return {
                  ...prev,
                  "id": e.target.value
                }
              })}
              >
                <option value="" disabled>
                  Select Subject
                </option>
                {reasonList.map((data) => {
                  return <option value={data.id}>{data.reason}</option>;
                })}
              </Select>
            </Col>
          </Row>
          <div className="text-center mt-5 mb-3">
            <SecBTN className={false ? "sec-btn1-deactive " : "sec-btn1"} disabled={false} onClick={handleReportSubmit}>
              Add
            </SecBTN>
          </div>
        </Modals>

      </div>
        )}


    </CustomModal >
      <CustomModal show={showAttendance} size="md" onHide={() => setShowAttendance(false)}>
        <h6 className="mb-4"><b>Attendance </b>| Batches - <b>{data.batch}</b></h6>
         <Row className="mb-4">
          <Col lg={4}>
            <div className={classes.attcard1}>
              <p>Present</p>
              <p>{attendanceData.overall_total_student_present}%</p>
            </div>
          </Col>
          <Col lg={4}>
            <div className={classes.attcard2}>
              <p>Absent</p>
              <p>{attendanceData.overall_total_student_absent}%</p>
            </div>
          </Col>
          <Col lg={4}>
            <div className={classes.attcard3}>
              <p>Total</p>
              <p>100</p>
            </div>
          </Col>
         </Row>         
         {attendanceData?.student_attendance_details?.map(item => {
          return (
            <div className={classes.attcard} key={item.batch_id}>
              <Row>
                <Col lg={3}>
                  <p>Batch</p>
                  <p className={classes.batch}>{item.batch_name}</p>
                </Col>
                <Col lg={3}>
                  <p>Present</p>
                  <p className={classes.present}>{item.total_present}</p>
                </Col>
                <Col lg={3}>
                  <p>Absent</p>
                  <p className={classes.absent}>{item.total_absent}</p>
                </Col>
                <Col lg={3}>
                  <p>Total</p>
                  <p className={classes.total}>{item.total_student}</p>
                </Col>
              </Row>
            </div>
          )
         })}
      </CustomModal>
      <Card key={data.id + data.batch}>
        <Row>
          {/*  */}
          <Col lg={9} md={12}>
            <div className="d-flex align-items-center gap-2 mb-1">
              <i class="bx bx-time-five"></i>
              <p className={classes.time}>
                {data.from_time} - {data.to_time}{" "}
                <span>{data.is_ended == 1 && "(Ended)"}</span>
              </p>
            </div>
            <Row>
              <Col lg={6} md={12}>
                <p className="mb-1">
                  Subject : <b>{data.subject}</b>
                </p>
                <p className="mb-1">
                  Topic : <b>{data.topic}</b>
                </p>
              </Col>
              <Col lg={6} md={12}>
                {!isEmpty(data.batch) && (
                  <p className="mb-1">
                    Batch : <b>{data.batch}</b>
                  </p>
                )}
                <p className="mb-1">
                  Campus : <b>{data.venue}</b>
                </p>
              </Col>
              
            </Row>
          </Col>
          {/*  */}
          <Col lg={3} md={12}>
            {data.course_report_status == 1 ? (
              <>
                <div className="text-center mb-2">
                  <SecBTN
                    className="sec-btn1 w-100"
                    style={{ background: "#2E8F01", color: "#fff" }}
                  >
                    <i class="bx bx-check-circle"></i> Course Report Added
                  </SecBTN>
                  {data.homework_status=='yes' &&
                    <SecBTN
                    className="sec-btn homework w-100"
                    style={{ marginTop:"10px" }}
                    onClick={handleHomeworkDetails}
                  >
                    <i class="bx bx-check-circle"></i> Homework Report
                  </SecBTN>}
                </div>
                <div className="text-center">
                  <SecBTN
                    className="sec-btn1 w-100"
                    onClick={viewAttendanceHandler}
                  >
                    View Attendance
                    {loading && <SmallLoader/>}
                  </SecBTN>
                </div>
              </>
            ) : (
              <>
                {data.is_ended == 1 ? (
                  <>
                    <div className="text-center mb-2">
                      <SecBTN
                        className="sec-btn1 w-100"
                        onClick={() => setShow(true)}
                      >
                        + Add Course Report
                      </SecBTN>
                    </div>
                    <div className="text-center">
                      <SecBTN className="sec-btn1 w-100"  onClick={viewAttendanceHandler}>View Attendance {loading && <SmallLoader/>}</SecBTN>
                    </div>
                  </>
                ) : (
                  ""
                )}
              </>
            )}
          </Col>
        </Row>
      </Card>
    </>
  );
};

export default ScheduleCard;
